import { SpsGlobalConfig } from '@interfaces/config/core/sps-global-config';

export const SPS: SpsGlobalConfig = {
  CONTACT_EMAIL: 'global.sps@spsglobal.com',
  FE_PROD_URL: 'https://www.spsglobal.com',
  CMS_PROD_URL: 'https://cms.spsglobal.com',
  SOCIAL_MEDIA_PLATFORMS: {
    YOUTUBE: { url: 'https://www.youtube.com/@SPSGlobal', sharing: null },
    LINKEDIN: {
      url: 'https://www.linkedin.com/company/sps/',
      followUrl: 'https://www.linkedin.com/company/sps/?isFollowingPage=true',
      sharing: {
        endpoint: 'https://www.linkedin.com/sharing/share-offsite',
        params: { url: '[URL]' },
      },
    },
    X: {
      url: 'https://twitter.com/SPSGlobal',
      sharing: {
        endpoint: 'https://twitter.com/intent/tweet',
        params: { url: '[URL]', hashtags: 'SPSGlobal', text: '[PAGE_TITLE]' },
      },
    },
    SPOTIFY: {
      url: 'https://open.spotify.com/show/2AFzHJK0oTTNDMLLsm8IHp?si=dceda4b1326a4aaa',
    },
  },
};
export const SPS_COLORS = {
  BLUE: '#0076a8',
  BLUE_DARK: '#004976',
  GRAY_LIGHT1: '#f4f3f0',
};
